module.exports = __webpack_public_path__ + "img/avatar-s-5.afa795d0.jpg";